<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <slot></slot>
      </div>
    </template>
    <v-date-picker
      no-title
      locale="th"
      color="black"
      ref="picker"
      v-model="date"
      :max="new Date().toISOString().substr(0, 10)"
      min="1930-01-01"
      @change="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ["value"],
  data: () => ({
    date: null,
    menu: false,
  }),
  mounted() {
    this.date = this.value;
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.$emit("input", date);
    },
  },
};
</script>

<style lang="scss" scoped></style>
